import { FC } from 'react'
import { Icon } from '@chakra-ui/react'

import { uniqueId } from '@/services'

export const Xls: FC = () => {
  const id = `clip${uniqueId()}`
  return (
    <Icon
      width="70px"
      height="70px"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3171_3611)">
        <path
          d="M43.75 2.1875V19.6875H61.25"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
        />
        <path
          d="M61.25 28.4375V19.6875L43.75 2.1875H8.75V28.4375"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M8.75 59.0625V67.8125H61.25V59.0625"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M32.1563 50.3125H28.4375L26.0312 46.375L23.4063 50.3125H19.6875L23.8438 43.9688L19.9062 37.8438H23.625L25.8125 41.7813L28 37.8438H31.9375L28 44.1875L32.1563 50.3125Z"
          fill="white"
        />
        <path d="M33.6873 50.3125V37.8438H36.9685V47.6875H41.781V50.3125H33.6873Z" fill="white" />
        <path
          d="M52.0624 46.5937C52.0624 47.4687 51.8436 48.125 51.4061 48.5625C50.9686 49 50.5311 49.6562 49.6561 49.875C48.7811 50.0937 48.1249 50.3125 47.0311 50.3125C46.1561 50.3125 45.4999 50.3125 44.8436 50.0937C44.1874 49.875 43.7499 49.875 43.0936 49.4375V46.375C43.7499 46.8125 44.4061 47.0312 45.0624 47.25C45.7186 47.4687 46.3749 47.4688 47.0311 47.4688C47.4686 47.4688 47.9061 47.4687 48.1249 47.25C48.3436 47.0312 48.5624 46.8125 48.5624 46.5937C48.5624 46.375 48.5624 46.375 48.3436 46.1562C48.1249 45.9375 48.1249 45.9375 47.9061 45.7187C47.6874 45.5 47.2499 45.2812 46.1561 44.8437C45.2811 44.4062 44.6249 44.1875 44.4061 43.75C44.1874 43.3125 43.7499 43.0937 43.5311 42.6562C43.3124 42.2187 43.3124 41.7812 43.3124 41.125C43.3124 40.0312 43.7499 39.1562 44.6249 38.5C45.4999 37.8437 46.5936 37.625 48.1249 37.625C49.4374 37.625 50.7499 37.8437 52.0624 38.5L50.9686 41.125C49.8749 40.6875 48.7811 40.25 47.9061 40.25C47.4686 40.25 47.2499 40.25 47.0311 40.4687C46.8124 40.6875 46.8124 40.9062 46.8124 41.125C46.8124 41.3437 47.0311 41.5625 47.2499 41.7812C47.4686 42 48.1249 42.2187 49.2186 42.875C50.3124 43.3125 50.9686 43.9687 51.4061 44.4062C51.8436 44.8437 52.0624 45.7187 52.0624 46.5937Z"
          fill="white"
        />
        <path
          d="M67.8125 28.4375H2.1875V59.0625H67.8125V28.4375Z"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <rect width="70px" height="70px" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  )
}
